// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9935761f","239":"73986f0c","455":"80d99831"}[chunkId] + ".chunk.js";
};